module.exports = __webpack_public_path__ + "img/Wp_2023.592db324.png";